/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../../constant"
import VacationService from "../../../service/attendance/vacation/vacationService"
import {
  TVacationIndividualGetReq,
  TYukyu,
} from "../../../service/attendance/vacation/TVacation"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { ModalOuter, TModalTypes } from "./VacationModalOuter"
import Spinner from "../../../components/Spinner"
import TextInput from "../../../components/InputWrapper/TextInput"

import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import dayjs from "dayjs"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

/**
 * 有給取得（個人）一覧モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const VacationListModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    syainId?: string
    nendo?: string
  }
> = (props) => {
  //#region [state]

  // 画面検索条件部
  const [部所名, set部所名] = useState<string>()
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()

  // Grid
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }
  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
    }
  }

  /**
   * データ取得
   * @param param
   * @param signal
   */
  const getData = async (
    param: TVacationIndividualGetReq,
    signal: AbortSignal
  ) => {
    const service = new VacationService()

    try {
      const res = await service.getIndividualList(param)
      if (res.data) {
        // 検索結果をstateにセット
        set部所名(res.data.部所名)
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)

        setGridData({ data: createCollectionView(res.data.有休リスト) })
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      flexGrid?.refresh()
    }
  }

  const createCollectionView = (data: Array<TYukyu>) =>
    new wjcCore.CollectionView(data, {})

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [pageSize, setPageSize] = useState<number>(10)
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  //#endregion

  //#region [effect]
  useEffect(() => {
    setAlertSource(undefined)

    if (flexGrid == null) return

    if (props.isShow) {
      const abortController = new AbortController()
      getData(
        { 年度: props.nendo, 社員ID: props.syainId },
        abortController.signal
      ).finally(() => {
        setIsSpinnerShow(false)
      })
    } else {
      // 非表示時中身を空にして閉じる
      set社員コード("")
      set社員氏名("")
      set部所名("")
      const newData = {
        data: createCollectionView([]),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "有給取得一覧"}
      setIsShow={props.setIsShow}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn  d-flex">
                  <TextInput
                    id="部所"
                    name="部所"
                    value={部所名}
                    isReadOnly={true}
                    setValue={set部所名}
                    maxLength={100}
                    placeholder="部所"
                    style={{ width: "200px" }}
                  />
                </li>
                <li className="list-cmn d-flex">
                  <TextInput
                    id="社員コード"
                    name="社員コード"
                    value={社員コード}
                    isReadOnly={true}
                    setValue={set社員コード}
                    maxLength={60}
                    placeholder="社員コード"
                  />
                  <TextInput
                    id="社員氏名"
                    name="社員氏名"
                    value={社員氏名}
                    isReadOnly={true}
                    setValue={set社員氏名}
                    maxLength={100}
                    placeholder="社員氏名"
                  />
                </li>
              </ul>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <FlexGridOuter
              flexGrid={flexGrid}
              setFlexGrid={setFlexGrid}
              gridConstantProperties={
                CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
              }
              gridData={gridData}
              setGridData={setGridData}
              pageNumber={0}
              gridId={"1"}
              isRestoreSearching={isRestoreSearching}
              setIsRestoreSearching={setIsRestoreSearching}
              gridInitialized={gridInitialized}
              setGridInitialized={setGridInitialized}
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridInitializedHandler={gridInitializedHandler}
              isShowGridRowPickupButton={false}
              isShowGridFooter={false}
              isShowGridHeader={false}
              style={{ height: "34rem" }}>
              <wjrGrid.FlexGridColumn
                width={120}
                header="取得日"
                binding="勤務日">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(context: TWijmoCellTemplateContext<TYukyu>) => {
                    let dt = ""
                    if (context.item.勤務日)
                      dt = dayjs(context.item.勤務日).format("YYYY/MM/DD")
                    return <>{dt}</>
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="休暇区分"
                binding="勤怠区分名称1"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={60}
                header="日数"
                format="N1"
                binding="日数"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={130}
                header="備考"
                binding="備考"></wjrGrid.FlexGridColumn>
            </FlexGridOuter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default VacationListModal
